export default "<div class=\"strapi-rich-text container\" [innerHTML]=\"renderedContent\"></div>\r\n";